import React, { Component } from "react";

class CampaignTypeStep extends Component {
  campaignTypes = [
    {
      id: "promotional",
      title: "Promotional Campaign",
      description: "Send offers, discounts and promotions to customers",
      icon: "🎯",
    },
    {
      id: "birthday",
      title: "Birthday Campaign",
      description: "Send birthday wishes and special birthday offers",
      icon: "🎂",
    },
    {
      id: "anniversary",
      title: "Anniversary Campaign",
      description: "Celebrate customer anniversaries with your business",
      icon: "🎊",
    },
  ];

  handleTypeSelect = (type) => {
    const { setCampaignType, updateFormData } = this.props;

    setCampaignType(type.id);
    updateFormData("type", type.id);

    if (type.id !== "promotional") {
      updateFormData("frequency", "One Time");
    }
  };

  styles = {
    container: {
      width: "100%",
    },

    heading: {
      fontSize: "24px",
      fontWeight: "600",
      color: "#4B5563",
      marginBottom: "24px",
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "16px",
    },

    card: {
      border: "1px solid #E5E7EB",
      borderRadius: "8px",
      padding: "16px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      backgroundColor: "#FFFFFF",
    },

    activeCard: {
      border: "1px solid #3B82F6",
      backgroundColor: "#EFF6FF",
    },

    icon: {
      fontSize: "32px",
      marginBottom: "8px",
    },

    title: {
      fontSize: "18px",
      fontWeight: "600",
      margin: "0 0 8px 0",
      color: "#111827",
    },

    description: {
      fontSize: "14px",
      color: "#6B7280",
      margin: 0,
      lineHeight: "1.5",
    },

    error: {
      color: "#EF4444",
      fontSize: "14px",
      marginTop: "8px",
    },
  };

  render() {
    const { campaignType, errors } = this.props;

    return (
      <div style={this.styles.container}>
        <h2 style={this.styles.heading}>Select Campaign Type</h2>

        <div style={this.styles.grid}>
          {this.campaignTypes.map((type) => (
            <div
              key={type.id}
              style={{
                ...this.styles.card,
                ...(campaignType === type.id
                  ? this.styles.activeCard
                  : {}),
              }}
              onClick={() => this.handleTypeSelect(type)}
            >
              <div style={this.styles.icon}>{type.icon}</div>

              <h3 style={this.styles.title}>{type.title}</h3>

              <p style={this.styles.description}>
                {type.description}
              </p>
            </div>
          ))}
        </div>

        {errors &&
          Object.prototype.hasOwnProperty.call(
            errors,
            "campaignType"
          ) && (
            <p style={this.styles.error}>
              {errors.campaignType}
            </p>
          )}
      </div>
    );
  }
}

export default CampaignTypeStep;